import { connect } from 'react-redux'
import MediaDrawerCollection from './MediaDrawerCollection'

const mapStateToProps = (state, props) => ({
  ...props,
  slidesEnabled: state.config.featureFlags.slides,
  playInEnabled: state.config.featureFlags.playIn,
  spotlightEnabled: state.config.featureFlags.spotlight,
  selectedDrawer: state.ui.selectedDrawer
})

export default connect(mapStateToProps)(MediaDrawerCollection)
